import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const ContainerEstadoClienteStyled = styled.div`
  min-height: calc(100vh - 130px);
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 2rem 1.5rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${FONT_STACK};
  -webkit-font-smoothing: antialiased;

  @media (max-width: 800px) {
    margin-top: 160px;
    min-height: calc(100vh - 160px);
    padding: 1rem 1rem 6rem;
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    margin-top: 160px;
    min-height: calc(100vh - 160px);
    padding: 2rem 1.5rem 6rem;
  }
`;

export const ContainerTitle = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 24px 24px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f3ebfa 100%);
  border: 1.5px solid rgba(76, 4, 140, 0.22);
  border-radius: 12px;
  box-shadow:
    0 1px 2px rgba(76, 4, 140, 0.06),
    0 12px 32px -10px rgba(76, 4, 140, 0.28);
  overflow: hidden;
  font-family: ${FONT_STACK};

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--violetaOscuro) 0%,
      var(--violeta) 50%,
      var(--naranja) 100%
    );
  }

  h2 {
    font-family: ${FONT_STACK};
    color: var(--violetaOscuro);
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin: 0 0 1.2rem 0;
    text-align: center;
  }

  input {
    font-family: ${FONT_STACK};
    width: 100%;
    max-width: 320px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1.5px solid rgba(76, 4, 140, 0.18);
    background: white;
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--grisOscuro);
    letter-spacing: -0.005em;
    margin-bottom: 1rem;
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease;

    &::placeholder {
      color: var(--grisMedio);
      font-weight: 400;
    }

    &:hover {
      border-color: rgba(76, 4, 140, 0.32);
    }

    &:focus {
      outline: none;
      border-color: var(--violetaOscuro);
      box-shadow: 0 0 0 3px rgba(203, 182, 219, 0.35);
    }
  }
`;

export const ContainerData = styled.div`
  position: relative;
  width: 100%;
  margin-top: 1.5rem;
  padding: 28px 24px 24px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f3ebfa 100%);
  border: 1.5px solid rgba(76, 4, 140, 0.22);
  border-radius: 12px;
  box-shadow:
    0 1px 2px rgba(76, 4, 140, 0.06),
    0 10px 28px -10px rgba(76, 4, 140, 0.22);
  overflow: hidden;
  font-family: ${FONT_STACK};

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--violetaOscuro) 0%,
      var(--violeta) 50%,
      var(--naranja) 100%
    );
  }

  h3 {
    font-family: ${FONT_STACK};
    color: var(--grisMedio);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin: 0 0 1.2rem 0;
    text-align: left;
    width: 100%;
  }

  p {
    font-family: ${FONT_STACK};
    color: var(--grisOscuro);
    font-size: 0.92rem;
    font-weight: 500;
    letter-spacing: -0.005em;
    line-height: 1.55;
    margin: 0 0 0.6rem 0;
    text-align: left;
    width: 100%;

    strong {
      color: var(--grisMedio);
      font-weight: 600;
      letter-spacing: 0.02em;
      font-size: 0.78rem;
      text-transform: uppercase;
      display: inline-block;
      min-width: 150px;
      margin-right: 8px;
    }
  }

  ul {
    margin: 0.4rem 0 0 0;
    padding-left: 1.4rem;

    li {
      font-family: ${FONT_STACK};
      color: var(--grisOscuro);
      font-size: 0.9rem;
      line-height: 1.55;
      list-style: disc;
      margin-bottom: 0.2rem;
    }
  }
`;

export const ServiciosSection = styled.div`
  margin-top: 1rem;
  padding-top: 1.2rem;
  border-top: 1px solid rgba(76, 4, 140, 0.12);

  h4 {
    font-family: ${FONT_STACK};
    color: var(--grisMedio);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin: 0 0 0.9rem 0;
  }
`;

export const ServiciosList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ServicioChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 13px 7px 11px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(76, 4, 140, 0.06) 100%
  );
  border: 1px solid rgba(76, 4, 140, 0.18);
  border-radius: 8px;
  font-family: ${FONT_STACK};
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--violetaOscuro);
  letter-spacing: -0.005em;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    transform 0.1s ease;

  svg {
    color: var(--violetaOscuro);
    font-size: 0.95rem;
    flex-shrink: 0;
  }

  &:hover {
    border-color: rgba(76, 4, 140, 0.32);
    transform: translateY(-1px);
  }
`;

export const ServiciosEmpty = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: rgba(212, 142, 0, 0.1);
  border: 1px solid rgba(212, 142, 0, 0.32);
  border-radius: 8px;
  font-family: ${FONT_STACK};
  font-size: 0.82rem;
  font-weight: 500;
  color: #8a5f00;
  letter-spacing: -0.005em;

  svg {
    font-size: 0.95rem;
  }
`;

export const EstadoBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 100px;
  font-family: ${FONT_STACK};
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: ${(props) =>
    props.$connected ? "rgba(26, 125, 29, 0.12)" : "rgba(212, 142, 0, 0.14)"};
  color: ${(props) => (props.$connected ? "#1a7d1d" : "#8a5f00")};
  border: 1px solid
    ${(props) =>
      props.$connected ? "rgba(26, 125, 29, 0.32)" : "rgba(212, 142, 0, 0.4)"};

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(props) => (props.$connected ? "#1a7d1d" : "#c08e00")};
  }
`;

export const ButtonBuscar = styled.button`
  font-family: ${FONT_STACK};
  min-width: 160px;
  padding: 10px 28px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.82rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: white;
  background: linear-gradient(
    180deg,
    var(--violetaPastelOscuro) 0%,
    var(--violetaOscuro) 100%
  );
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(76, 4, 140, 0.25);
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.08s ease;

  &:hover {
    background: linear-gradient(
      180deg,
      var(--violeta) 0%,
      var(--violetaPastelOscuro) 100%
    );
    box-shadow: 0 4px 14px rgba(76, 4, 140, 0.38);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 2px 8px rgba(76, 4, 140, 0.25),
      0 0 0 3px rgba(203, 182, 219, 0.45);
  }

  &:disabled {
    background: linear-gradient(180deg, #b0b0b0 0%, #909090 100%);
    cursor: not-allowed;
    box-shadow: none;
  }
`;
